import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../../Contexts/AuthContext";
import { updateFerme } from "../../../api/fermeApi";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import './fermeEdit.css';
import { useTranslation } from "react-i18next";
import { FiHome, FiMapPin, FiChevronLeft, FiCheckCircle, FiLoader, FiEdit3 } from "react-icons/fi";
import { GiFarmTractor } from "react-icons/gi";

export default function FermeEdit() {
    const { user, setUser } = useContext(AuthContext);
    const navigate = useNavigate();
    const { t } = useTranslation();
    
    const [nom, setNom] = useState('');
    const [adresse, setAdresse] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (user?.ferme) {
            setNom(user.ferme.nom || '');
            setAdresse(user.ferme.adresse || '');
        }
    }, [user]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!nom || nom.trim() === '') {
            swal(t('adminFerme.swal.errorTitle'), t('adminFerme.swal.nameRequired'), 'error');
            return;
        }

        setLoading(true);

        const fermeData = {
            nom: nom,
            adresse: adresse || null,
        };

        try {
            const updatedFerme = await updateFerme(user.ferme_id, fermeData);
            
            setUser({
                ...user,
                ferme: updatedFerme
            });

            swal(t('adminFerme.swal.successTitle'), t('adminFerme.swal.successText'), 'success');
            navigate('/admin');
        } catch (error) {
            console.error('Update error:', error);
            const errorMsg = error.response?.data?.message || t('adminFerme.swal.genericError');
            swal(t('adminFerme.swal.errorTitle'), errorMsg, 'error');
        } finally {
            setLoading(false);
        }
    }

    if (!user?.ferme) {
        return (
            <div className="fe-page">
                <div className="fe-loading">
                    <FiLoader className="fe-loading-icon" />
                    <span>{t('adminFerme.loading')}</span>
                </div>
            </div>
        );
    }

    return (
        <div className="fe-page">
            {/* Header */}
            <div className="fe-header">
                <button type="button" className="fe-back-btn" onClick={() => navigate("/admin")}>
                    <FiChevronLeft /> {t('adminFerme.back')}
                </button>
                <div className="fe-header-content">
                    <div className="fe-header-icon">
                        <GiFarmTractor />
                    </div>
                    <div>
                        <h1 className="fe-title">{t('adminFerme.title')}</h1>
                        <p className="fe-subtitle">{t('adminFerme.subtitle')}</p>
                    </div>
                </div>
            </div>

            {/* Current Info Card */}
            <div className="fe-info-card">
                <div className="fe-info-header">
                    <FiEdit3 className="fe-info-icon" />
                    <span>{t('adminFerme.currentInfo')}</span>
                </div>
                <div className="fe-info-grid">
                    <div className="fe-info-item">
                        <span className="fe-info-label">{t('adminFerme.fields.currentName')}</span>
                        <span className="fe-info-value">{user.ferme.nom || '—'}</span>
                    </div>
                    <div className="fe-info-item">
                        <span className="fe-info-label">{t('adminFerme.fields.currentAddress')}</span>
                        <span className="fe-info-value">{user.ferme.adresse || t('adminFerme.fields.addressNotSet')}</span>
                    </div>
                </div>
            </div>

            {/* Form Card */}
            <form onSubmit={handleSubmit} className="fe-form">
                <div className="fe-section">
                    <div className="fe-section-header">
                        <div className="fe-section-icon"><FiHome /></div>
                        <h3 className="fe-section-title">{t('adminFerme.subtitle')}</h3>
                    </div>

                    <div className="fe-fields">
                        <div className="fe-field">
                            <label className="fe-label fe-required">
                                <FiHome className="fe-label-icon" />
                                {t('adminFerme.fields.name')}
                            </label>
                            <input
                                type="text"
                                className="fe-input"
                                value={nom}
                                onChange={(e) => setNom(e.target.value)}
                                required
                                placeholder={t('adminFerme.placeholders.name')}
                            />
                        </div>

                        <div className="fe-field">
                            <label className="fe-label">
                                <FiMapPin className="fe-label-icon" />
                                {t('adminFerme.fields.address')}
                            </label>
                            <input
                                type="text"
                                className="fe-input"
                                value={adresse}
                                onChange={(e) => setAdresse(e.target.value)}
                                placeholder={t('adminFerme.placeholders.address')}
                            />
                        </div>
                    </div>
                </div>

                {/* Actions */}
                <div className="fe-actions">
                    <button type="button" className="fe-btn-secondary" onClick={() => navigate("/admin")}>
                        <FiChevronLeft /> {t('adminFerme.actions.cancel')}
                    </button>
                    <button type="submit" className="fe-btn-primary" disabled={loading}>
                        {loading ? (
                            <><FiLoader className="fe-btn-spin" /> {t('adminFerme.actions.updating')}</>
                        ) : (
                            <><FiCheckCircle /> {t('adminFerme.actions.update')}</>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
}